import { css } from 'linaria';

export const contentList = css`
  display: flex;
  flex-direction: column;
  margin: 0 calc(-1 * var(--space-400));
`;

export const listTitle = css`
  padding: var(--space-200) 0 var(--space-100);
`;

export const additionalTextStyle = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-50);

  &:not(:first-child) {
    margin-top: var(--space-200);
  }
`;

export const drawerHeaderStyle = css`
  padding-top: var(--space-200);
  padding-bottom: var(--space-200);
`;

export const closeButton = css`
  margin-right: calc(-1 * var(--space-75));
`;
